import { render, staticRenderFns } from "./NotificationArrow.vue?vue&type=template&id=393be7e9&scoped=true&"
import script from "./NotificationArrow.vue?vue&type=script&lang=ts&"
export * from "./NotificationArrow.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationArrow.vue?vue&type=style&index=0&id=393be7e9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393be7e9",
  null
  
)

export default component.exports